(function() {
  document.addEventListener("DOMContentLoaded", function() {
    let sizeSelectors = document.querySelector('.size_option-container input:checked');

    if (sizeSelectors) {
      let customChangeEvent = new Event('change', {
        bubbles: true,
        cancelable: true
      });

      sizeSelectors.dispatchEvent(customChangeEvent);
    }
  });
})();
